import { referrerService } from "@/modules/contacts/features/referrer/store/services/referrer-service";
import { REFERRER_SERVICE_TAG } from "@/modules/contacts/features/referrer/utils/referrer-service-tags";

const getReferrer = referrerService.injectEndpoints({
  endpoints: builder => ({
    getReferrer: builder.query({
      query: id => `referrers/${id}`,
      providesTags: (result, error, id) => [{ type: REFERRER_SERVICE_TAG, id }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetReferrerQuery } = getReferrer;

